<ng-container *ngIf="animalsForList.length > 0; else empty">
  <app-animal-list-item
    [animals]="animalsForList"
    [pageable]="false"
    [hideDetails]="true"
  ></app-animal-list-item>
</ng-container>

<ng-template #empty>
  <div class="w-full text-center py-4 text-color-secondary">
    {{ emptyText }}
  </div>
</ng-template>